export interface UpdateShippedOrder {
  id: string;
  salesOrderHeaderId: string;
  salesOrderStockAllocationId: string;
  salesOrderAndLineNo: string;
  purchaseOrderAndLineNo: string;
  customerOrderRef: string;
  sellingCompany: string;
  customerAccount: string;
  customerName: string;
  orderNo: number;
  sequence: number;
  status: string;
  allocationType: string;
  productType: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  quantity: number;
  unitOfMeasure: string;
  noOfItems: number;
  deliveryDate: Date;
  supplier: string;
  supplierId: string;
  trackingNo: string;
  proformaOrder: string;
  proformaPaid: string;
  creditCheckPassed: string;
  deliveryAddress: string;
  countryName: string;
  enteredBy: string;
  euCountry: string;
}
